import useSWR from "swr";
import { endpointsEntitlements } from "lib/actions/endpoints/endpointsEntitlements";
import { fetcher } from "lib/actions/fetcher";
import { WorkspaceEntitlementsStatus } from "lib/types/workspaces/WorkspaceEntitlementsStatus";

export const useWorkspaceEntitlementsStatusByProjectId = (
  projectId: number,
) => {
  const {
    data: workspaceEntitlementsStatus,
    isLoading,
    error,
    mutate,
  } = useSWR<WorkspaceEntitlementsStatus>(
    projectId && endpointsEntitlements.getEntitlementsByProjectId(projectId),
    fetcher,
  );

  return {
    workspaceEntitlementsStatus,
    isLoading,
    hasError: !!error,
    mutate,
  };
};
